import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import ClearIcon from "@mui/icons-material/Clear";
import { Tooltip } from "@mui/material";
import { formatPhoneNumber } from "../../../pages/setup/components/managementcompanies/utils/phoneUtils";

const EditContactRow = ({
  row,
  handlers,
  onRowClick,
  onSelectContact,
  selectedContact,
}) => {
  const { roleKey, roleLabel, contact } = row;
  const [localContact, setLocalContact] = useState(contact);

  useEffect(() => {
    setLocalContact(contact);
  }, [contact]);

  const handleRowClick = () => {
    if (!contact) return;
    // Call the passed-in function to set the selected contact.
    if (onSelectContact) onSelectContact(contact);
    if (onRowClick) onRowClick(row);
  };

  const editFields = ["contactName", "phone1", "cellPhone", "emailAddress"];
  return (
    <tr
      onClick={handleRowClick}
      className={`border-t cursor-pointer ${
        selectedContact && selectedContact.contactID === contact?.contactID
          ? "bg-cyan-100"
          : "bg-transparent hover:bg-cyan-50 hover:shadow-lg"
      }`}
    >
      <Tooltip title="Remove Contact" enterDelay={1000}>
        <td className="px-2 py-1 border border-white text-center bg-white">
          <button
            onClick={(e) => {
              e.stopPropagation();
              handlers.removeContactForRole(roleKey, localContact?.contactID);
            }}
            className="text-gray-500 hover:text-red-500 transition duration-150"
            aria-label="Remove contact"
          >
            <ClearIcon fontSize="small" />
          </button>
        </td>
      </Tooltip>
      <Tooltip title={roleLabel} enterDelay={1000}>
        <td className="px-2 py-1 border font-medium text-nowrap overflow-ellipsis">
          {roleLabel}
        </td>
      </Tooltip>
      {editFields.map((field, idx) => {
        let displayValue = "";
        if (localContact) {
          displayValue =
            field === "phone1" || field === "cellPhone"
              ? formatPhoneNumber(localContact[field])
              : localContact[field] || "";
        }
        return (
          <Tooltip key={idx} title={displayValue} enterDelay={1000}>
            <td className="px-2 py-1 border">
              <span className="block overflow-ellipsis text-nowrap">
                {displayValue}
              </span>
            </td>
          </Tooltip>
        );
      })}
    </tr>
  );
};

EditContactRow.propTypes = {
  row: PropTypes.shape({
    roleKey: PropTypes.string.isRequired,
    roleLabel: PropTypes.string.isRequired,
    contact: PropTypes.object,
  }).isRequired,
  handlers: PropTypes.shape({
    removeContactForRole: PropTypes.func.isRequired,
  }).isRequired,
  onRowClick: PropTypes.func,
  onSelectContact: PropTypes.func,
  selectedContact: PropTypes.object,
};

export default EditContactRow;
